import { format } from "date-fns";
import { hu } from "date-fns/locale";
import { Card, CardContent } from "../ui/card";
import { Car, Wallet, CreditCard, Landmark } from "lucide-react";
import { StudioSection } from "./StudioSection";

/** Előzmény nap (nem „ma”) — hero összbevétel + 4 csempe */
export function StudioHistoryKpiBento({ historyStats, selectedDate }) {
  if (!historyStats) return null;
  const dateLabel = format(new Date(selectedDate), "yyyy. MMMM d.", { locale: hu });

  return (
    <div className="studio-dash-bento">
      <StudioSection
        id="stats-history-day"
        title="Kiválasztott nap"
        subtitle={dateLabel}
      >
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 items-stretch">
          <Card className="glass-card kpi-card studio-kpi-hero lg:col-span-4 flex flex-col border-orange-500/25">
            <CardContent className="p-5 sm:p-6 flex flex-col flex-1 justify-between min-h-[168px]">
              <p className="text-xs font-medium uppercase tracking-wider text-orange-400/90">Összes bevétel (nap)</p>
              <p className="text-3xl sm:text-4xl font-bold text-white tabular-nums leading-tight mt-3">
                {(historyStats.total_revenue || 0).toLocaleString("hu-HU")}
                <span className="text-lg sm:text-xl font-semibold text-slate-500 ml-1.5">Ft</span>
              </p>
              <p className="mt-4 text-sm text-slate-500 border-t border-slate-800/80 pt-3">Részletek jobbra</p>
            </CardContent>
          </Card>
          <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-2 gap-3">
            <HistTile label="Elkészült autók" value={historyStats.cars_completed || 0} icon={Car} tone="green" numeric />
            <HistTile
              label="Készpénz"
              value={`${(historyStats.cash_revenue || 0).toLocaleString("hu-HU")}`}
              suffix=" Ft"
              accent="text-green-400"
              icon={Wallet}
              tone="green"
            />
            <HistTile
              label="Kártya"
              value={`${(historyStats.card_revenue || 0).toLocaleString("hu-HU")}`}
              suffix=" Ft"
              accent="text-blue-400"
              icon={CreditCard}
              tone="blue"
            />
            <HistTile
              label="Átutalás"
              value={`${(historyStats.transfer_revenue || 0).toLocaleString("hu-HU")}`}
              suffix=" Ft"
              accent="text-purple-300"
              icon={Landmark}
              tone="purple"
            />
          </div>
        </div>
      </StudioSection>
    </div>
  );
}

function HistTile({ label, value, suffix, icon: Icon, accent = "text-white", numeric, tone = "green" }) {
  const toneBg = { green: "bg-green-500/15", cyan: "bg-cyan-500/15", blue: "bg-blue-500/15", purple: "bg-purple-500/15" };
  const toneText = { green: "text-green-400", cyan: "text-cyan-400", blue: "text-blue-400", purple: "text-purple-300" };
  const bg = toneBg[tone] || "bg-orange-500/10";
  const ic = toneText[tone] || accent;
  return (
    <Card className="glass-card kpi-card studio-kpi-tile border-orange-500/20">
      <CardContent className="p-3 sm:p-4 h-full flex flex-col justify-between">
        <p className="text-[10px] sm:text-xs text-slate-500 uppercase tracking-wide">{label}</p>
        <div className="flex items-end justify-between gap-2 mt-2">
          {numeric ? (
            <p className="text-lg sm:text-2xl font-bold text-white tabular-nums leading-snug">{value}</p>
          ) : (
            <p className={`text-lg sm:text-2xl font-bold tabular-nums leading-snug ${accent}`}>
              {value}
              {suffix ? <span className="text-xs font-normal text-slate-500">{suffix}</span> : null}
            </p>
          )}
          <div className={`w-9 h-9 rounded-xl ${bg} flex items-center justify-center shrink-0`}>
            <Icon className={`w-5 h-5 ${ic}`} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
